<template>
  <div class="wimut">
    <menuBox :step="1"></menuBox>
    <div class="wimut-content">
      <div class="wimut-box">
        <p class="bt">กู้เงินได้ง่าย ๆ ลำดับความสำคัญทางการเงินของคุณ</p>
        <span class="title">ช่วยให้ผู้ใช้ได้รับการสนับสนุนทางการเงินออนไลน์เพื่อตอบสนองความต้องการของผู้ใช้</span>
        <div class="btn" @click="step">หน้าต่อไป</div>
      </div>
      <div class="oneNetList">
        <div class="item">
          <img src="../assets/quick1.png" alt="">
          <div>
            <p>ข้อมูลเชิงลึกทางการเงิน</p>
            <span>ให้การวิเคราะห์และคำแนะนำทางการเงินเชิงลึก</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/quick2.png" alt="">
          <div>
            <p>สายตายาว</p>
            <span>มุ่งมั่นที่จะเป็นผู้นำในอุตสาหกรรม</span>
          </div>
        </div>
        <div class="item" style="background-color:rgba(0, 56, 122, 1) ;">
          <img src="../assets/quick3.png" alt="">
          <div>
            <p style="color: #fff;">บนพื้นฐานของความไว้วางใจ</p>
            <span style="color: #fff;">โดยยึดความไว้วางใจจากลูกค้าเป็นค่านิยมหลัก</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="infoBox">
      <div class="left">
        <div class="title">การร่วมมือทางอย่างเป็นทางการ สินเชื่อที่ใช้ง่ายอยู่ในการควบคุม</div>
        <div class="text">SUMMIT CAPITAL LEASING CO., LTD. (ต่อไปเรียกว่า "SUMMIT" เลขทะเบียน 0105537051400)
          เป็นบริษัทที่ลงทะเบียนอย่างถูกต้องในประเทศไทยและได้รับใบอนุญาตจากหน่วยงานควบคุมทางการเงินที่เกี่ยวข้อง
          โดยมุ่งมุ่งให้บริการสินเชื่อส่วนบุคคลและบริการทางการเงิน SUMMIT ได้ให้สิทธิ์ให้กับ WIMUT FAMILY COMPANY
          LIMITED (ต่อไปเรียกว่า "WIMUT") ที่จะจัดส่งสินเชื่อผ่านแอปพลิเคชัน Easy Baht

          ความร่วมมือของเรากับ SUMMIT ทำให้ผู้ใช้สามารถเข้าถึงผลิตภัณฑ์สินเชื่อส่วนบุคคลของ SUMMIT
          ได้อย่างสะดวกผ่านแอปพลิเคชันของเรา พร้อมกับได้รับการสนับสนุนทางเทคโนโลยีและบริการที่มีคุณภาพจากเรา SUMMIT
          รับผิดชอบในการให้บริการผลิตภัณฑ์สินเชื่อและบริการทางการเงินที่เกี่ยวข้องเพื่อรักษาความปลอดภัยของข้อมูลส่วนบุคคลของผู้ใช้และสิทธิ์ความเป็นส่วนตัวของผู้ใช้
          ในขณะเดียวกัน WIMUT รับผิดชอบในการพัฒนา การดูแลรักษาและดำเนินการแอปพลิเคชัน
          เพื่อให้ผู้ใช้ได้รับประสบการณ์การใช้บริการที่ปลอดภัยและมีคุณภาพที่ดีที่สุด</div>
      </div>
      <img src="../assets/infoBox.png" alt="">
    </div> -->
    <div class="easiest-box">
      <div class="easiestBt">ประวัติบริษัท</div>
      <div class="easiestTitle">มุ่งเน้นนวัตกรรมและความเป็นเลิศในการให้บริการทางการเงิน</div>
      <div class="mission-box">
        <img src="../assets/Illustration.png" alt="">
        <div class="mission-right">
          <div class="bt">
            กู้เงินง่าย ๆ
          </div>
          <div class="text">
            กู้เงินง่าย ๆ เป็นสถาบันการเงินมืออาชีพที่ได้รับอนุญาตจาก PICO
            ในประเทศไทย เรียกว่า WIMUT FAMILY CO., LTD.
            บริษัทมุ่งมั่นที่จะสร้างสรรค์นวัตกรรมและความเป็นเลิศในบริการทางการเงิน
            และมอบผลิตภัณฑ์ทางการเงินที่ปรับแต่งได้แก่ลูกค้าซึ่งขับเคลื่อนด้วยเทคโนโลยีเพื่อตอบสนองความต้องการที่หลากหลาย
            เรามุ่งเน้นไปที่การส่งเสริมการพัฒนาอุตสาหกรรมผ่านการระดมทุนและนวัตกรรมผลิตภัณฑ์
            และได้รับความไว้วางใจและการยอมรับจากตลาดด้วยการบริการลูกค้าที่เป็นเลิศ
            เป้าหมายของเราคือการมอบโซลูชันทางการเงินที่มีประสิทธิภาพ ปลอดภัย
            และยืดหยุ่นแก่ลูกค้าเพื่อช่วยให้พวกเขาบรรลุเป้าหมายทางการเงิน
          </div>
        </div>
      </div>
    </div>
    <div class="explore-box">
      <div class="explore-left">
        <p>สำรวจธุรกิจของเรา</p>
        <div class="title">
          เลือกเราเพื่อเริ่มต้นการเดินทางอย่างมืออาชีพเพื่อการเติบโตของความมั่งคั่งและการควบคุมความเสี่ยง </div>
        <!-- <span>Get Quote Now</span> -->
      </div>
      <div class="explore-right">
        <div class="itemLine">
          <div class="item">
            <img src="../assets/explore1.png" alt="">
            <div>
              <p>ให้คำปรึกษาผลิตภัณฑ์ทางการเงิน</p>
              <span>ให้การวิเคราะห์ผลิตภัณฑ์ทางการเงินอย่างมืออาชีพเพื่อช่วยให้ลูกค้าเลือกโซลูชั่นการลงทุนและการเงินที่เหมาะสม </span>
            </div>
          </div>
          <div class="item">
            <img src="../assets/explore2.png" alt="">
            <div>
              <p>บริการบริหารจัดการสินทรัพย์</p>
              <span>มีความเชี่ยวชาญในการจัดสรรสินทรัพย์
                ให้บริการโซลูชั่นการแข็งค่าของสินทรัพย์และการจัดการความเสี่ยงสำหรับบุคคลและธุรกิจ</span>
            </div>
          </div>
        </div>
        <div class="itemLine">
          <div class="item">
            <img src="../assets/explore3.png" alt="">
            <div>
              <p>บริการประเมินสินเชื่อ</p>
              <span>ใช้เครื่องมือวิเคราะห์ขั้นสูงเพื่อให้ลูกค้าได้รับการประเมินเครดิตและคำแนะนำการจัดการเครดิตที่แม่นยำ</span>
            </div>
          </div>
          <div class="item">
            <img src="../assets/explore4.png" alt="">
            <div>
              <p>รายงานการวิเคราะห์ตลาด</p>
              <span>เผยแพร่รายงานแนวโน้มอุตสาหกรรมและการวิเคราะห์ตลาดเป็นประจำเพื่อสนับสนุนลูกค้าในการตัดสินใจลงทุนอย่างมีข้อมูล</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="people-box">
      <div class="bt">ทำความรู้จักกับเรา</div>
      <div class="content">
        <div class="list">
          <img src="../assets/people1.png" alt="">
          <div class="box">
            <p>Elara Penrose</p>
            <span>หัวหน้านักวิเคราะห์การเงินระหว่างประเทศ</span>
          </div>
        </div>
        <div class="list">
          <img src="../assets/people2.png" alt="">
          <div class="box">
            <p>Seraphina Voss</p>
            <span>นักวิชาการการเงินดีเด่นแห่งเอเชีย</span>
          </div>
        </div>
        <div class="list">
          <img src="../assets/people3.png" alt="">
          <div class="box">
            <p>Thorne Radcliffe</p>
            <span>ผู้เชี่ยวชาญด้านการแยกหุ้นและการเงินของประเทศไทย</span>
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "home",
  components: {
    menuBox,
    footerBox
  },
  data() {
    return {
      type: 1,
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "categories" });
    },
  },
};
</script>

<style lang="less" scoped>
.wimut-content {
  position: relative;

  .oneNetList {
    width: 100%;
    position: absolute;
    bottom: -80px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;

    .item {
      margin-right: 30px;
      padding: 34px 40px;
      background-color: #fff;
      box-shadow: 3px 1px 44px 0px rgba(0, 0, 0, 0.07);
      box-sizing: border-box;

      img {
        margin-bottom: 10px;
        width: 48px;
        height: 40px;
      }

      p {
        margin-bottom: 10px;
        font-size: 24px;
        font-family: Montserrat, Montserrat;
        font-weight: bold;
        color: #252B42;
      }

      span {
        font-size: 14px;
        font-family: Montserrat, Montserrat;
        font-weight: 500;
        color: #737373;
      }
    }
  }

  .wimut-box {
    background-image: url(../assets/home.png);
    width: 100%;
    height: 750px;
    background-size: 100% 100%;
    padding: 180px 310px 0 310px;
    overflow: hidden;
    box-sizing: border-box;

    .bt {
      max-width: 600px;
      margin-bottom: 35px;
      font-size: 58px;
      font-family: Roboto, Roboto;
      font-weight: 800;
      color: #FFFFFF;
      line-height: 80px;
    }

    .title {
      display: block;
      margin-bottom: 35px;
      max-width: 600px;
      font-size: 20px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #F4F4F4;
      line-height: 30px;
    }

    .btn {
      display: inline-block;
      cursor: pointer;
      padding: 15px 35px;
      text-align: center;
      background: #F26621;
      font-size: 16px;
      font-family: Roboto, Roboto;
      color: #FFFFFF;
      border-radius: 37px;
    }
  }
}

.easiest-box {
  margin: 250px 0 120px;

  .easiestBt {
    max-width: 600px;
    font-size: 54px;
    font-family: Roboto, Roboto;
    font-weight: bold;
    color: #252B42;
    margin: 0 auto 22px;
    text-align: center;
  }

  .easiestTitle {
    max-width: 600px;
    font-size: 20px;
    font-family: Roboto, Roboto;
    font-weight: 500;
    color: #737373;
    text-align: center;
    margin: 0 auto;
    text-align: center;
  }

  .mission-box {
    margin-top: 74px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 310px;

    img {
      margin-right: 37px;
      width: 617px;
      height: 429px;
    }

    .mission-right {
      .bt {
        margin-bottom: 20px;
        font-size: 38px;
        font-family: Roboto, Roboto;
        font-weight: bold;
        color: #252B42;
      }

      .text {
        margin-bottom: 45px;
        font-size: 24px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #737373
      }
    }
  }
}

.explore-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 83px 310px;
  background: #F8FBFF;

  .explore-left {
    margin-right: 84px;
    max-width: 390px;

    p {
      margin-bottom: 35px;
      font-size: 38px;
      font-family: Roboto, Roboto;
      font-weight: bold;
      color: #252B42;
    }

    .title {
      display: block;
      font-size: 24px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #737373;
      line-height: 35px;
    }

    span {
      cursor: pointer;
      margin-top: 40px;
      display: table;
      background-color: rgba(0, 56, 122, 1);
      padding: 15px 36px;
      font-size: 16px;
      font-family: Roboto, Roboto;
      font-weight: bold;
      color: #FFFFFF;
      border-radius: 37px;
    }
  }

  .explore-right {

    .itemLine {
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;

      .item {
        width: 50%;
        display: flex;
        margin: 0 69px 0 0;
        padding: 45px 30px;
        background: #FFFFFF;
        box-sizing: border-box;
        box-shadow: 0px 8px 32px 0px rgba(48, 104, 156, 0.1);

        img {
          margin-right: 10px;
          width: 42px;
          height: 42px;
        }

        p {
          margin-bottom: 14px;
          font-size: 24px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #252B42;
          line-height: 40px;
        }

        span {
          font-size: 18px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: rgba(37, 43, 66, 0.6);
          line-height: 24px;
        }
      }

      .item:nth-child(2) {
        margin-right: 0;
      }
    }
  }
}

.people-box {
  padding: 120px 310px;
  box-sizing: border-box;

  .bt {
    text-align: center;
    margin-bottom: 80px;
    font-size: 54px;
    font-family: Roboto, Roboto;
    font-weight: bold;
    color: #252B42;
  }

  .content {
    display: flex;

    .list {
      margin-right: 44px;
      display: flex;
      flex-direction: column;
      border-radius: 40px 0 0 0;

      img {
        width: 404px;
        height: 372px;
      }

      .box {
        height: 120px;
        padding: 20px;
        background: #00387A;
        box-sizing: border-box;
        text-align: center;
        border-radius: 0 0 40px 0;

        p {
          margin-bottom: 10px;
          font-size: 24px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #FFFFFF;
        }

        span {
          font-size: 18px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }

    .list:nth-child(3) {
      margin-right: 0;
    }
  }
}

.infoBox {
  margin-top: 254px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 80px 310px;
  box-sizing: border-box;
  background: #F0F6FF;

  .left {
    margin-right: 30px;

    .title {
      margin-bottom: 40px;
      font-weight: bold;
      font-size: 38px;
      color: #252B42;
      line-height: 40px;
    }

    .text {
      font-size: 24px;
      color: #333333;
      line-height: 35px;
    }
  }

  img {
    width: 389px;
    height: 321px;
  }
}
</style>
